var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 85.994,
    viewBox: "0 0 86 85.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3464",
    "data-name": "Group 3464",
    transform: "translate(-250 -1284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448",
    transform: "translate(-1334.375 112.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user_3_",
    "data-name": "user (3)",
    transform: "translate(1608 1198.164)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38483",
    "data-name": "Path 38483",
    d: "M20.371,1038.25a10.28,10.28,0,1,0,10.282,10.279A10.3,10.3,0,0,0,20.371,1038.25Zm0,3.1a7.157,7.157,0,1,1-5.083,2.1,7.155,7.155,0,0,1,5.083-2.1Zm0,20.275C9.231,1061.625,0,1069.3,0,1079.086H2.911c0-7.945,7.644-14.55,17.464-14.55s17.461,6.605,17.461,14.55h2.914c0-9.789-9.234-17.461-20.374-17.461Z",
    transform: "translate(0 -1038.25)",
    fill: "#b0beff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user_3_2",
    "data-name": "user (3)",
    transform: "translate(1606 1200.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38483-2",
    "data-name": "Path 38483",
    d: "M20.371,1038.25a10.28,10.28,0,1,0,10.282,10.279A10.3,10.3,0,0,0,20.371,1038.25Zm0,3.1a7.157,7.157,0,1,1-5.083,2.1,7.155,7.155,0,0,1,5.083-2.1Zm0,20.275C9.231,1061.625,0,1069.3,0,1079.086H2.911c0-7.945,7.644-14.55,17.464-14.55s17.461,6.605,17.461,14.55h2.914c0-9.789-9.234-17.461-20.374-17.461Z",
    transform: "translate(0 -1038.25)",
    fill: "#4258bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3455",
    "data-name": "Group 3455",
    transform: "translate(-1163 -135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dollar",
    d: "M106.656,464.754A38.986,38.986,0,1,1,145.65,425.77,39.028,39.028,0,0,1,106.656,464.754Zm0-80.98a42,42,0,1,0,42.008,42A42.041,42.041,0,0,0,106.656,383.773Z",
    transform: "translate(1350.336 1035.227)",
    fill: "#b0beff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dollar-2",
    "data-name": "dollar",
    d: "M106.656,464.754A38.986,38.986,0,1,1,145.65,425.77,39.028,39.028,0,0,1,106.656,464.754Zm0-80.98a42,42,0,1,0,42.008,42A42.041,42.041,0,0,0,106.656,383.773Z",
    transform: "translate(1348.336 1037.227)",
    fill: "#4258bf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3457",
    "data-name": "Group 3457",
    transform: "translate(19 60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38488",
    "data-name": "Path 38488",
    d: "M15.083,1036.36a1.809,1.809,0,0,0-1.968,1.6v11.826a1.826,1.826,0,0,0,2,1.574,1.826,1.826,0,0,0,2-1.574V1037.96a1.422,1.422,0,0,0-.585-1.139,2.307,2.307,0,0,0-1.446-.461Z",
    transform: "translate(276.707 205.027)",
    fill: "#b0beff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38489",
    "data-name": "Path 38489",
    d: "M12.813,1038.25a2.057,2.057,0,0,0,0,4H24.659a2.057,2.057,0,0,0,0-4Z",
    transform: "translate(273.086 208.637)",
    fill: "#b0beff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3456",
    "data-name": "Group 3456",
    transform: "translate(22.344 -1.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38486",
    "data-name": "Path 38486",
    d: "M15.083,1036.36a1.809,1.809,0,0,0-1.968,1.6v11.826a1.826,1.826,0,0,0,2,1.574,1.826,1.826,0,0,0,2-1.574V1037.96a1.422,1.422,0,0,0-.585-1.139,2.307,2.307,0,0,0-1.446-.461Z",
    transform: "translate(253.551 206.64)",
    fill: "#4258bf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38487",
    "data-name": "Path 38487",
    d: "M12.813,1038.25a2.057,2.057,0,0,0,0,4H24.659a2.057,2.057,0,0,0,0-4Z",
    transform: "translate(249.93 210.25)",
    fill: "#4258bf",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStep);
export default __webpack_public_path__ + "static/media/home-step.5789bd2a1870bbe9d0851c65a7f9182d.svg";
export { ForwardRef as ReactComponent };